import notify from "devextreme/ui/notify";
import { toastOptions, toastStack } from "../../utils/toastConfig";

const Notification = (message, type) => {
  notify(
    {
      message,
      ...toastOptions,
      type,
    },
    {
      ...toastStack,
    }
  );
};
export default Notification;
